import {
  NBS_API_UPDATE_NEARBY_CONNECT_SETUP_REQUEST,
  NBS_API_UPDATE_NEARBY_CONNECT_SETUP_SUCCESS,
  NBS_API_UPDATE_NEARBY_CONNECT_SETUP_FAILURE,
  NBS_API_RESET_UPDATE_CONNECT,
} from '../../constants/actions';

const initialState = {
  isFetching: null,
  error: null,
  timestamp: null,
  response: {},
  status: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_UPDATE_NEARBY_CONNECT_SETUP_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: false,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'request',
      };
    case NBS_API_UPDATE_NEARBY_CONNECT_SETUP_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        response: action.response,
        timestamp: new Date().toUTCString(),
        status: 'success',
      };
    case NBS_API_UPDATE_NEARBY_CONNECT_SETUP_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'fail',
      };
    case NBS_API_RESET_UPDATE_CONNECT:
      return initialState;
    default:
      return state;
  }
}
